import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "abas_desbloqueadas";

function abasDesbloqueadas() {
  try { return JSON.parse(sessionStorage.getItem(CACHE_KEY) || "[]"); } catch { return []; }
}
function marcarDesbloqueada(aba) {
  const atual = abasDesbloqueadas();
  if (!atual.includes(aba)) {
    atual.push(aba);
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(atual));
  }
}

export default function AbaGuard({ aba, children }) {
  const [bloqueada, setBloqueada] = useState(null); // null = carregando, true/false
  const [senha, setSenha] = useState("");
  const [enviando, setEnviando] = useState(false);

  const checar = useCallback(async () => {
    if (abasDesbloqueadas().includes(aba)) { setBloqueada(false); return; }
    try {
      const r = await axios.get(`${API}/config/seguranca`);
      const lista = r.data?.abas_bloqueadas || [];
      const temSenhaCfg = !!r.data?.senhas_configuradas?.configuracoes;
      if (lista.includes(aba) && temSenhaCfg) setBloqueada(true);
      else setBloqueada(false);
    } catch { setBloqueada(false); }
  }, [aba]);

  useEffect(() => { checar(); }, [checar]);

  const tentar = async () => {
    setEnviando(true);
    try {
      await axios.post(`${API}/config/verificar-aba`, { aba, senha });
      marcarDesbloqueada(aba);
      setBloqueada(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Senha incorreta");
    } finally { setEnviando(false); }
  };

  if (bloqueada === null) {
    return <div className="p-10 text-center text-slate-400" data-testid={`aba-guard-loading-${aba}`}>Verificando acesso…</div>;
  }
  if (bloqueada) {
    return (
      <div className="max-w-md mx-auto mt-10" data-testid={`aba-guard-${aba}`}>
        <Card className="bg-white border-slate-200">
          <CardHeader>
            <div className="flex items-center gap-2">
              <Lock className="w-5 h-5 text-slate-600" />
              <CardTitle>Acesso restrito</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-slate-500">Esta aba foi bloqueada em Configurações → Segurança.</p>
            <Label>Senha</Label>
            <Input type="password" value={senha} onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && !enviando && tentar()} data-testid={`aba-guard-senha-${aba}`} />
            <Button onClick={tentar} disabled={enviando} className="w-full bg-slate-900 hover:bg-slate-800 text-white" data-testid={`aba-guard-entrar-${aba}`}>
              {enviando ? "Verificando…" : "Entrar"}
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }
  return children;
}
